import { useMemo } from 'react';
import { PageFilterConfigsDto } from '@asset-metrix/portal-gateway-client-js';
import { useQuery } from '@tanstack/react-query';

import { fetchFilterCustomization } from '../api/portalGateway/tableFilterCustomization';

export function useActiveCustomPageFilters(
  config: PageFilterConfigsDto | undefined,
  reference: string | null
) {
  const hasCustomizablePageFilters =
    config?.customizablePageFilters === true &&
    config?.customPageFilterColumns != null &&
    config.customPageFilterColumns.length > 0;

  const { data: storedCustomFilterData } = useQuery({
    queryKey: [
      'filterCustomization',
      {
        referenceType: 'page' as const,
        reference: reference ?? '',
      },
    ],
    queryFn: fetchFilterCustomization,
    enabled: hasCustomizablePageFilters && reference != null,
  });

  const activeCustomFilterConfigs = useMemo(
    () =>
      storedCustomFilterData?.data?.columns
        ?.map(
          (c) =>
            config?.customPageFilterColumns?.find((i) => i.id === c.columnId)
              ?.customFilter
        )
        .filter((c) => c != null) ?? [],
    [config?.customPageFilterColumns, storedCustomFilterData?.data?.columns]
  );

  const customizationSettled =
    !hasCustomizablePageFilters || storedCustomFilterData != null;

  return {
    activeCustomFilterConfigs,
    customizationSettled,
    hasActiveCustomPageFilters: activeCustomFilterConfigs.length > 0,
    hasCustomizablePageFilters,
  };
}
